import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }

import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import { TabItem } from '@/shared/components/pageHeader/tabItem';
import { ATTENDANT_TRIAGE_FLOWS_ENABLED, NLP_ENABLED } from '@/store/app/featureTypes';
import BotPreviewModal from '@/features/bots/components/botTestTool/BotPreviewModal.vue';
import appInsights from '@/shared/services/appInsights';
import UpgradeBanner from '@/features/bots/components/UpgradeBanner.vue';
import { HeaderButton } from '@/shared/components/pageHeader/headerButton';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Bots',
  setup(__props) {

const store = useStore();
const isWorkspaceFeatureEnabled = (feature: string) => computed(() => store.getters.isWorkspaceFeatureEnabled(feature));
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const botPreviewActive = ref(false);

const tabs = computed<TabItem[]>(() => {
  const tabs = [];

  if (isWorkspaceFeatureEnabled(ATTENDANT_TRIAGE_FLOWS_ENABLED)) {
    tabs.push({ name: 'Tasks', route: 'bots-tasks' });
  }

  tabs.push({ name: 'Flows', route: 'bots-flows' });

  if (isWorkspaceFeatureEnabled(NLP_ENABLED)) {
    tabs.push({ name: 'FAQs', route: 'bots-answers' });
    tabs.push({ name: 'Intents', route: 'bots-intents' });
    tabs.push({ name: 'Active Learning', route: 'bots-active-learning' });
  }

  return tabs;
});

const buttons: HeaderButton[] = [
  {
    clickHandler: () => openBotPreviewModal(),
    content: 'Preview your Bot',
    variant: 'secondary',
  },
];

function openBotPreviewModal() {
  botPreviewActive.value = true;
  appInsights.trackEvent({ name: 'Preview your Bot clicked' }, { workspaceId: currentWorkspace.value.id });
}

function closeBotPreviewModal() {
  botPreviewActive.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UpgradeBanner),
    _createVNode(PageHeader, {
      title: "Bot Studio",
      description: "Automate your first response and data capture or create your own bot experiences",
      tabs: tabs.value,
      buttons: buttons
    }, null, 8, ["tabs"]),
    _createVNode(_component_router_view),
    (botPreviewActive.value)
      ? (_openBlock(), _createBlock(BotPreviewModal, {
          key: 0,
          onCancel: closeBotPreviewModal
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})